(() => {
  const dialog = document.getElementById('HomeopathyRequestDialog');
  if (!dialog) return;
  document.body.classList.add('homeopathy-request-page');
  const root=()=>document.querySelector('.page-content--product'),productForm=()=>root()?.querySelector('[data-request-selection]'),unit=()=>{const data=productData(),options=[...root().querySelectorAll('select[data-option-name]')].map(el=>el.selectedOptions[0]?.textContent||'').join(' ');if(String(data?.id)==='12151867998548')return'συσκευασίες';if(/pills/i.test(data?.handle||''))return'pills';if(/caps/i.test(data?.handle||''))return'κάψουλες';if(/granules|pellets/i.test(options))return'g';if(/pills/i.test(options))return'pills';if(/caps/i.test(options))return'κάψουλες';return'φιαλίδια'};const productData=()=>{const node=root()?.querySelector('.request-product-data');if(!node)return null;try{return JSON.parse(node.textContent)}catch{return null}};const currentQuantity=()=>{const scope=root();const candidates=[scope?.querySelector('input[name="quantity"]:not([type="hidden"])'),scope?.querySelector('[data-quantity-input]'),productForm()?.querySelector('[name="quantity"]')].filter(Boolean);return candidates[0]?.value||(location.pathname.includes('pills')?'10':'1')};const syncQuantity=()=>{const hidden=productForm()?.querySelector('[name="quantity"]');if(hidden)hidden.value=currentQuantity()};const snapshot=()=>{const data=productData(),form=productForm();if(!data||!form)return'';const variantId=form.querySelector('[name="id"]')?.value,variant=data.variants.find(v=>String(v.id)===String(variantId));const fields=[...root().querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]')].filter(el=>!el.disabled&&!['button','submit','file'].includes(el.type)&&(!['radio','checkbox'].includes(el.type)||el.checked)).map(el=>`${el.name.slice(11,-1)}: ${el.tagName==='SELECT'?[...el.selectedOptions].map(o=>o.textContent.trim()).join(', '):el.value.trim()}`).filter(text=>text.split(':').slice(1).join(':').trim());return[data.title,`Μορφή / Δυναμοποίηση: ${[...root().querySelectorAll('select[data-option-name]')].map(el=>[...el.selectedOptions].map(o=>o.textContent.trim()).join(', ')).join(' / ')||variant?.title||'Προς επιβεβαίωση'}`,`Ποσότητα: ${currentQuantity()} ${unit()}`,...fields].join('\n')};
  let pendingSummary = null;
  const fillSummary = () => {
    if (pendingSummary === null) return;
    const field = dialog.querySelector('[id="166896-textarea"]');
    if (!field) return;
    field.value = pendingSummary;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
    pendingSummary = null;
  };
  const open = () => {
    const scope = root();
    if (!scope) return;
    for (const field of [...scope.querySelectorAll('[required]')].filter(el => !el.disabled)) {
      if (!field.checkValidity()) { field.reportValidity(); return; }
    }
    syncQuantity();
    pendingSummary = snapshot();
    if (!pendingSummary) return;
    fillSummary();
    dialog.showModal();
    dialog.querySelector('input:not([type="hidden"]), textarea')?.focus();
  };
  const refresh = () => root()?.querySelectorAll('.request-open').forEach(button => button.removeAttribute('disabled'));
  document.addEventListener('click', event => {
    const button = event.target.closest('.request-open');
    if (!button || !root()?.contains(button)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open();
  }, true);
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-request-selection]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open();
  }, true);
  dialog.querySelector('.request-close')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  new MutationObserver(fillSummary).observe(dialog, {childList: true, subtree: true});
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(refresh).observe(main, {childList: true, subtree: true});
  refresh();
})();
